import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';


import {userAccountsDomainsService} from '../apiclient/userAccountsDomains/userAccountsDomains.service';
import {ToolsService} from '../tools/tools.service';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GuardUserDomainSalemethodService implements CanActivate {

  constructor(
    private router: Router,
    private userAccountsDomainsService: userAccountsDomainsService,
    private tools: ToolsService
  ) {
  }

  determineUrl(): boolean {
    const origin = window.location.origin;

    // Mode test
    if (!environment.production) {
      return true;
    }

    // Mode production
    else if (origin.includes('projetclient-209012.ew.r.appspot.com')) {
      return true;
    }

    return origin == 'https://webshop.fulleapps.io';
  }

  canActivate(
    next: ActivatedRouteSnapshot | any,
    state: RouterStateSnapshot): any {

    let determineUrl = this.determineUrl();

    return new Promise(resolve => {

      this.tools.removeStor("domainUser");
      this.tools.setFavicone(false);

      if (!determineUrl) {

        if (!next.params.webshopId) {
          //location.replace(urlto);
          resolve(false);
          return;
        }

        this.userAccountsDomainsService.getUserAccountDomainByWebshopId(window.location.host, next.params.webshopId
        ).subscribe((domain: any) => {

          let flag = false;
          let url: any = null;
          if (domain && domain.id_point_of_sale) {

            let denomination = domain.denomination ? domain.denomination.replaceAll(' ', '-') : null;
            denomination = denomination ? denomination.toLowerCase() : null;

            if (denomination) {

              url = "/s/" + denomination + "/" + domain.id_webshop;
              url += next.params.smId ? "/" + next.params.smId : '';
              url += next.params.inId ? "/" + next.params.inId : '';
              url += next.params.value ? "/" + next.params.value : '';

              flag = state.url == url ? true : false;

              if (!flag) {
                //urlto = url;
              }

              this.tools.setStor("domainUser", true);
              this.tools.setFavicone(true);
            } else {
              flag = false;
            }
          }

          resolve(flag);
        })
      } else {
        resolve(true);
      }
    })
  }
}
